// Initialize a global array to store the product handles
var currentProductHandles = []; 
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        if (this.form) {
          this.variantIdInput.disabled = false;
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.submitButton = this.querySelector('[type="submit"]');
          this.submitButtonText = this.submitButton.querySelector('span');
  
          if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
  
          this.hideErrors = this.dataset.hideErrors === 'true';
        }

      }

      /**
       * The <subscription-options> card that prices the variant being added, or null.
       *
       * Matched on the variant, not on position in the page. Recommendation, upsell and
       * quick-add forms sit on the same page as the product's own card, and a selling
       * plan belongs to one product: sending the card's plan id with someone else's
       * variant makes Shopify reject the whole add, so the item silently never arrives.
       * The card already publishes a price for every one of its own variants, which is
       * what identifies it here.
       */
      subscriptionOptionsFor(variantId) {
        if (!variantId) return null;

        const candidates = [
          this.closest('.shopify-section')?.querySelector('subscription-options'),
          ...document.querySelectorAll('subscription-options'),
        ];

        for (const element of candidates) {
          if (!element) continue;
          try {
            const data = JSON.parse(element.querySelector('.po-variant-data').textContent);
            if (data.variants?.[variantId]) return element;
          } catch (error) {
            // No usable data on this one — try the next.
          }
        }
        return null;
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        // Cross-sell popup is no longer triggered here. It now runs after the add response,
        // inside the fetch .then() below, so it can be cart-type-aware: page cart type shows
        // the popup, drawer type opens the drawer, and the cart page never shows the popup.

        const giftAtc = evt.target.closest('.free-gift-addtocart');
        const rotGiftAtc = evt.target.closest('.rot_free-gift-addtocart');

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        //this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);

        /**subscription — send selling_plan only when Subscribe & Save is selected**/
        // The hidden input lives in <subscription-options> and is bound to this form
        // by id, so it can arrive in FormData. Set it explicitly here so a stale or
        // disabled input can never submit the wrong purchase type.
        formData.delete('selling_plan');

        const subscriptionOptions = this.subscriptionOptionsFor(String(formData.get('id') || ''));

        if (subscriptionOptions) {
          // Keyed off the radio's value, not a class name, so restyling the cards
          // cannot silently stop subscriptions being sent.
          const checked = subscriptionOptions.querySelector('input[name="purchase_type"]:checked');
          const isSubscribing = checked?.value === 'subscription';
          const sellingPlanId = subscriptionOptions.querySelector('.po-selling-plan')?.value || '';

          if (isSubscribing && sellingPlanId) {
            formData.set('selling_plan', sellingPlanId);
          }
        }

        /**bulk buy**/
        let quantityQuickView;
        const selectedBulkBuy = document.querySelector('.main-bulk-buy .bulk-buy-inner:not(.hidden) input[name="bulk_buy_qty"]:checked');
        if (selectedBulkBuy) {
          quantityQuickView = selectedBulkBuy.closest('label').dataset.qty;
        }
        let currentQuantity = null;
        const isMainBuyButton = this.submitButton.classList.contains('main_buy_button');
        // Each buy button reads its own stepper: the sticky strip sits outside <product-info>,
        // so a document-wide lookup let its value override the picked multipack.
        const stickyStrip = this.submitButton.closest('.main-add-to-basket');
        const quantityScope = stickyStrip || this.closest('product-info') || this;
        const quantityInput = quantityScope.querySelector('.price_quantity_wrapper .quantity__input');

        const bulkBuyWrapper = document.querySelector('.main-bulk-buy');
        const bulkBuyVisible = !!(
          bulkBuyWrapper &&
          (bulkBuyWrapper.offsetWidth || bulkBuyWrapper.offsetHeight || bulkBuyWrapper.getClientRects().length)
        );
        const resolveQuantity = () => {
          const stepped = parseInt(quantityInput?.value, 10);
          if (stickyStrip) return stepped > 0 ? stepped : 1;
          if (stepped > 1) return stepped;
          if (bulkBuyVisible && quantityQuickView) return quantityQuickView;
          return quantityInput?.value || quantityQuickView || 1;
        };

        // XVD
        const mainAddToBasketContainer = document.querySelector('.main-add-to-basket');
        const bulk_buy_utm_parameter = this.submitButton.classList.contains('bulk_buy_utm_parameter');
        const isInsideMainAddToBasket = this.submitButton.closest('.main-add-to-basket') !== null;

        const xvdStored = sessionStorage.getItem('xvd_found');
        let quantity = 1; // default fallback

        if (isMainBuyButton) {
          if (bulk_buy_utm_parameter) {
            // If xvd parameter was stored in session, disable bulk logic
            if (xvdStored === 'true') {
              quantity = quantityInput?.value || quantityQuickView || 1;
            } else {
              if(isInsideMainAddToBasket){
                quantity = resolveQuantity();
              } else {
                quantity = quantityQuickView || 1;
              }
            }
          } else {
            quantity = resolveQuantity();
          }

          currentQuantity = quantity;
          const productForm = this.submitButton.closest('product-form');

          if (productForm) {
            const hiddenInput = productForm.querySelector('.updated-product-quantity');
            if (hiddenInput) {
              hiddenInput.value = quantity;
              formData.set('quantity', hiddenInput.value);
            } 
          } 
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        if (giftAtc && !rotGiftAtc) {
          formData.append('properties[_gift]', 'true');
          formData.append('properties[_auto]', 'true');
          formData.append('properties[_d_gift]', 'false');
          formData.append('properties[_gift_uid]', Date.now().toString());
        }

        if (rotGiftAtc) {
          const rotBar =
            document.getElementById('rotating-gift-bar') ||
            document.getElementById('rotating-gift-data');
          const rotCampaignId = rotBar?.dataset.rotCampaignId || '';
          formData.append('properties[_gift]', 'true');
          formData.append('properties[_rotational_freebie]', 'true');
          formData.append('properties[_rotational_period]', rotCampaignId);
          formData.append('properties[_gift_uid]', Date.now().toString());
        }

        // Show the freebie overlay loader for gift add-to-carts (e.g. the cart-page "add the
        // gift back" strip) so it matches the cart-drawer strip (addCartDrawerGift). It's
        // cleared by refreshCart / the freebie cartUpdate subscriber once the gift is added.
        if (giftAtc || rotGiftAtc) {
          window.setFreebieLoading?.(true);
        }

        config.body = formData;

        // Cross-sell popup opens IMMEDIATELY on add (like the old flow) instead of waiting
        // for the add request to round-trip. Cart-type aware: only "page" cart type (no
        // <cart-drawer>/<cart-notification>), never on the cart page itself, and not for
        // gift add-to-carts. The add still proceeds below; the .then() just syncs the count.
        const showCrossSell =
          !this.cart &&
          !giftAtc &&
          !rotGiftAtc &&
          !document.querySelector('cart-items') &&
          this.submitButton.getAttribute('data-handles') &&
          document.getElementById('upsell-product-list') &&
          typeof crossSellPopup === 'function';
        if (showCrossSell) crossSellPopup(this.submitButton);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // A gift add errored — no refresh runs below, so clear the freebie overlay here
              // (no-op for non-gift adds, which never turned it on).
              window.setFreebieLoading?.(false);
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              //this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            // No <cart-drawer>/<cart-notification> on the page — i.e. "page" cart type,
            // or we're on the cart page itself.
            if (!this.cart) {
              // On the cart page (e.g. "Customers also bought"): the popup markup isn't
              // rendered there, so just re-render the cart list and let the freebie
              // pipeline run — never open a popup.
              if (document.querySelector('cart-items')) {
                this.publishCartUpdate(response, formData.get('id'));
                window.refreshCart?.();
                return;
              }
              // Page cart type on a PDP/collection: the popup already opened above (immediate),
              // so just keep the header count in sync. If there was no popup to show, fall
              // back to the cart page.
              if (showCrossSell) {
                this.syncCartBubble();
              } else {
                window.location = window.routes.cart_url;
              }
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (!window.location.pathname.includes('/cart')) {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  this.cart.renderContents(response);
                });
              }
            }
          })
          .catch((e) => {
            console.error(e);
            // Network error — clear the freebie overlay so it can't stick (no-op for non-gift adds).
            window.setFreebieLoading?.(false);
          })
          .finally(() => {
            if (!giftAtc && !rotGiftAtc) {
              this.submitButton.classList.remove('loading');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner')?.classList.add('hidden');
            }
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      // Fire the shared cartUpdate event (skipped on error) so the freebie/reward pipeline runs.
      publishCartUpdate(response, variantId) {
        if (this.error) return;
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: variantId,
          cartData: response,
        });
      }

      // Refresh the header cart-count bubble in place without a full reload. Replaces only the
      // bubble's inner HTML so we never nest a duplicate #cart-icon-bubble inside itself.
      syncCartBubble() {
        fetch(window.location.pathname, { headers: { Accept: 'text/html' } })
          .then((r) => r.text())
          .then((html) => {
            const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#cart-icon-bubble');
            if (!fresh) return;
            document.querySelectorAll('#cart-icon-bubble').forEach((el) => {
              el.innerHTML = fresh.innerHTML;
            });
          })
          .catch(() => {});
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          //this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

async function crossSellPopup(submitButton) {
  const clickedProductTitle = submitButton.getAttribute('data-title');
  const clickedProductDescription = submitButton.getAttribute('data-description');
  const clickedProductImage = submitButton.getAttribute('data-product-image');
  const metaFieldProductHandles = submitButton.getAttribute('data-handles');

  if (metaFieldProductHandles) {
    const productHandles = metaFieldProductHandles.split(',').map(item => item.trim()).filter(item => item !== "");
    let cartHandles = [];

    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      const handles = cart.items.map(item => item.handle);
      cartHandles = handles.join(',');
    } catch (error) {
      console.error('Error fetching cart:', error);
    }

    const filteredProductHandles = productHandles.filter(handle => !cartHandles.includes(handle));
    currentProductHandles = filteredProductHandles;

    const upsellProductList = document.getElementById('upsell-product-list');
    // The popup markup isn't rendered on the cart template — bail out rather than throw
    // on a null container. The cart page has its own add flow (no popup by design).
    if (!upsellProductList) return;
    let crossSellItems = [];

    const createProductCard = (productUrl, index) => {
      const card = document.createElement('li');
      card.classList.add('owl-slide', 'slider-item');

      fetch(productUrl)
        .then(response => response.text())
        .then(data => {
          card.innerHTML = data;

          // Grab product data from rendered card button and push to crossSellItems
          const btn = card.querySelector('[data-product-handle]');
          if (btn) {
            crossSellItems.push({
              brand:    btn.getAttribute('data-brand') || '',
              category: btn.getAttribute('data-item_category2') || btn.getAttribute('data-item_category3') || '',
              id:       btn.getAttribute('data-master_id') || '',
              name:     btn.getAttribute('data-prod_name') || '',
              position: index + 1,
              price:    btn.getAttribute('data-price')?.replace(/[^0-9.,]/g, '').replace(',', '.') || '',
              variant:  '',
            });
          }

          upsellProductList.appendChild(card);
          const currentLength = currentProductHandles.length;
          card.classList.add(`card-length-${currentLength}`);
          initializeCrossSellCarousel();
        })
        .catch(error => {
          console.error('Error fetching product card:', error);
        });
    };

    upsellProductList.innerHTML = '';

    currentProductHandles.forEach((handle, index) => {
      const productUrl = `/products/${handle}?view=card`;
      createProductCard(productUrl, index);
    });

    if (currentProductHandles.length > 0) {
      const checkIfCardsAdded = setInterval(() => {
        const upsellProductList = document.getElementById('upsell-product-list');
        if (upsellProductList && upsellProductList.children.length > 0) {
          const mainPopupCard = document.querySelector('.main-popup-card');
          if (mainPopupCard) {
            mainPopupCard.classList.remove('hidden');
            document.querySelector('body').classList.add('cross-sell-open');
          }
          clearInterval(checkIfCardsAdded);
        }

        let productPopupTitle = document.querySelector('.product-popup-title');
        let productSubheadingDescription = document.querySelector('.product-subheading-description');
        let productfeaturedImage = document.querySelector('.cross-sell-product-featured');
        if (productPopupTitle) {
          productPopupTitle.innerText = clickedProductTitle;
        }
        if (productSubheadingDescription) {
          productSubheadingDescription.innerText = clickedProductDescription;
        }
        if (productfeaturedImage) {
          productfeaturedImage.src = clickedProductImage;
        }
      }, 100);
    } else {
      const mainPopupCard = document.querySelector('.main-popup-card');
      if (mainPopupCard) {
        document.querySelector('body').classList.remove('cross-sell-open');
        mainPopupCard.classList.add('hidden');
      }
    }
  } else {
    const mainPopupCard = document.querySelector('.main-popup-card');
    if (mainPopupCard) {
      document.querySelector('body').classList.remove('cross-sell-open');
      mainPopupCard.classList.add('hidden');
    }
  }
}


// Cross cell popup close
var crossPopupCloseButton = document.querySelector('#close-popup');
var continueShopping = document.querySelector('.continue-shopping_button');
var crossSellModal = document.querySelector('.main-popup-card');
var overlay = document.querySelector('.cross-cell-main-overlay');

function closeModal() {
  crossSellModal?.classList.add('hidden');
  document.querySelector('body').classList.remove('cross-sell-open', 'overflow-hidden');
}
// Close popup on clicking the close button
crossPopupCloseButton?.addEventListener('click', function() {
  closeModal()
});
continueShopping?.addEventListener('click', function(){
  closeModal()
})
// Close popup when clicking outside of the modal or overlay
document.addEventListener('click', (event) => {
  if (event.target.classList.contains('cross-cell-outer-container')) {
     closeModal()
  }
});

function initializeCrossSellCarousel() {
  // Destroy the existing carousel and reinitialize it
  if ($('.cross-cell-products-owl-carousel').data('owl.carousel')) {
      $('.cross-cell-products-owl-carousel').trigger('destroy.owl.carousel');
  }

  // Initialize the Owl Carousel
  $('.cross-cell-products-owl-carousel').owlCarousel({
      loop: true,
      nav: true,
      margin: 10,
      responsive: {
          0: {
            items: 1.5,
            dots: false,
            margin: 20,
            nav: false,
          },
          600: {
            items: 2,
            dots: false,
            margin: 20,
            nav: false,
          },
          768: {
            items: 2,
            dots: false,
            margin: 20
          },
          1024: {
            items: 3,
            dots: false,
            margin: 20
          },
      }
  });
}                                                  
